import React from 'react';
import classNames from 'classnames';

// STYLE
import './TagChip.sass'

const TagChip = ({ main, label } ) => {
  return (
    <div className={classNames('TagChip', {
      'TagChip--main': main,
    })}>
      { main ? '* ' : null}
      { label }
    </div>
  )
}

export {
  TagChip
}